exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagination[data-v-c4cf4fea]{text-align:center}.pagination button[data-v-c4cf4fea]{margin:0 5px;background-color:#f4f4f5;color:#606266;outline:none;border-radius:2px;padding:0 4px;vertical-align:top;display:inline-block;font-size:13px;min-width:35.5px;height:28px;line-height:28px;cursor:pointer;box-sizing:border-box;text-align:center;border:0}.pagination button[disabled][data-v-c4cf4fea]{color:#c0c4cc;cursor:not-allowed}.pagination button.active[data-v-c4cf4fea]{cursor:not-allowed;background-color:#409eff;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-c4cf4fea","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pagination.vue
// module id = 274
// module chunks = 2